import { fetch } from '@/utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryAllFqaDicts(query) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/fqa-dicts`,
    method: 'get',
    params: {
      scope: 'all',
      ...query,
    },
  });
}

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryFqaDicts(
  {
    page, size, direction, sort,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/fqa-dicts`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryFqaDict(fqaDictIdId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/fqa-dicts/${fqaDictIdId}`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  id
 * @param  name
 * @param  parentId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addFqaDict(
  {
    id,
    name,
    code,
    isActive,
    remark,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/fqa-dicts`,
    method: 'post',
    data: {
      id,
      name,
      code,
      isActive,
      remark,
    },
  });
}

/**
 * 更新
 * @param fqaDictIdId
 * @param  id
 * @param  createAt
 * @param  name
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateFqaDict(fqaDictIdId, {
  name,
  code,
  isActive,
  remark,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/fqa-dicts/${fqaDictIdId}`,
    method: 'patch',
    data: {
      name,
      code,
      isActive,
      remark,
    },
  });
}

/**
 * 删除
 * @param fqaDictIdId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteFqaDict(fqaDictIdId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/fqa-dicts/${fqaDictIdId}`,
    method: 'delete',
  });
}

export default {};
